var $ = require('jquery');
var angular = require('angular');

/**
 * Search in toolbar (angular module with controller for the search layer)
 */
(function() {
    'use strict';

    var DEFAULT_SEARCH_RESULTS = 5,
        MORE_RESULTS_INCREMENT = 5;

    var toolbarSearch;

    var search = angular.module('diy.search', ['ngSanitize']);

    diy.angular.loadFactories(search, ['diyl10n']);

    search.filter('isEmpty', function() {
        return $.isEmptyObject;
    });

    search.factory('toolbarSearch', function() {
        return toolbarSearch;
    });

    search.factory('appsCatalog', function() {
        return diy.editor.appsCatalog;
    });

    search.controller('SearchLayerCtrl', [
        '$scope', 'toolbarSearch', 'appsCatalog', '$timeout', 'diyl10n',
        function($scope, toolbarSearch, appsCatalog, $timeout, diyl10n) {

            /**
             * Refreshes the squeeze box + scrollbar when view changes
             */
            var refreshScroller = function() {
                // We use timeout to update the squeezebox after content has stabilized
                // and Angular has finished rendering the elements. We don't have
                // ngAnimate in 1.0.5 so we can't hook to ngShow
                $timeout(function() {
                    toolbarSearch.refreshScroller();
                });
            };

            /**
             * Flattens the results object which is mapped by providerName.
             * This results in an array with each element having a 'providerName' property
             * @param {Object.<String, Array>} results
             * @returns {Array}
             */
            var flattenResults = function(results) {
                var newResults = [];

                angular.forEach(results, function(providerResults, providerName) {
                    newResults = newResults.concat(
                        providerResults.map(function(result) {
                            result.providerName = providerName;
                            return result;
                        })
                    );
                });

                return newResults;
            };

            /**
             * Creates a map of categoryId => results from a flat array of results
             * @param results
             * @returns {Object.<String, Array>}
             */
            var mapResultsToCategories = function(results) {
                var map = {};

                results.forEach(function(result) {
                    var resultCategory;

                    switch (result.providerName) {
                        case 'elements':
                            var isInstalledFn = appsCatalog.isWebcomponentInstalled;
                            if (result.type !== 'webcomponent' || isInstalledFn(result.webcomponentId)) {
                                resultCategory = 'installed';
                            } else {
                                resultCategory = 'noninstalled';
                            }
                            break;

                        case 'features':
                            resultCategory = result.categoryId || result.providerName;
                            break;

                        default:
                            resultCategory = result.providerName;
                    }

                    map[resultCategory] = map[resultCategory] || [];
                    map[resultCategory].push(result);
                });

                return map;
            };

            /**
             * Formats the search results by category so we can use them in the view
             * @param {Object} results
             * @returns {Object}
             */
            var formatResults = function(results) {
                if ($.isEmptyObject(results)) {
                    return {};
                }

                results = flattenResults(results);
                results = mapResultsToCategories(results);
                return results;
            };

            /**
             * Search results
             *
             * Holds the results returned by the search providers.
             * @type {Object}
             */
            $scope.searchResults = {};
            /**
             * Search results formatted by category, used as view model
             *
             * This model changes when the search is triggered or when the installed
             * status of a webcomponent changes
             *
             * @type {Object}
             */
            $scope.results = {};

            $scope.categories = [{
                id: 'help',
                title: diyl10n('toolbarSearch.categoryLabels.help')
            }, {
                id: 'installed',
                title: diyl10n('toolbarSearch.categoryLabels.installed')
            }, {
                id: 'noninstalled',
                title: diyl10n('toolbarSearch.categoryLabels.noninstalled')
            }];

            /**
             * How many results to display in each category.
             *
             * If not specified, the default number or results will be displayed.
             * This is changed when pressing the "Show more results" button
             *
             * @type {Object.<string, number>}
             */
            $scope.resultLimit = {};

            /**
             * Keyboard selected result
             * @type {{catIndex: int, catId: string, position: int}}
             */
            $scope.selection = null;

            /**
             * The maximum number of results that are shown in the interface
             * per category. This is increased by the "Show more results" button
             * @param {String} catId
             * @returns {number}
             */
            $scope.getResultLimit = function(catId) {
                if (!this.resultLimit[catId]) {
                    return DEFAULT_SEARCH_RESULTS;
                }

                return this.resultLimit[catId];
            };

            /**
             * Reset the number of displayed results to the default, by removing
             * all values from the resultLimit object
             */
            $scope.resetResultLimit = function() {
                this.resultLimit = {};
            };

            $scope.showMoreResults = function(catId) {
                var resultsNo = this.getResultLimit(catId);
                this.resultLimit[catId] = resultsNo + MORE_RESULTS_INCREMENT;
                refreshScroller();

                $(document).trigger('diy-editor-search-showmoreclick');
            };

            $scope.hasHelpSearch = function() {
                return toolbarSearch.hasHelpSearch();
            };

            $scope.resultClick = function(e, index, result, catId) {
                toolbarSearch.openResult(e, index, result, catId);
            };

            $scope.calculateViewResults = function() {
                this.results = formatResults(this.searchResults);
                this.updateVisibleCategories();
            };

            /**
             * Handler for keyboard navigation
             * Called from outside of the angular module, so be careful to call
             * $scope.$apply() when changing the model
             *
             * @return {Boolean} true to prevent default behavior on the searchbox
             */
            $scope.handleKeyNav = function(e) {
                var keyCodes = $.ui.keyCode;

                switch (e.keyCode) {
                    case keyCodes.DOWN:
                    case keyCodes.RIGHT:
                        $scope.$apply(function() {
                            $scope.moveSelection(1);
                        });
                        return true;

                    case keyCodes.UP:
                    case keyCodes.LEFT:
                        $scope.$apply(function() {
                            $scope.moveSelection(-1);
                        });
                        return true;

                    case keyCodes.ENTER:
                    case keyCodes.NUMPAD_ENTER:
                        if (this.selection !== null) {
                            this.openSelection();
                            return true;
                        }
                        return false;

                    default:
                        return false;
                }
            };

            /**
             * Moves the keyboard selection up/down
             * @param {int} direction 1 for down, -1 for up
             */
            $scope.moveSelection = function(direction) {
                if (direction === 1) {
                    this.goToNextVisibleIndex();
                } else if (direction === -1) {
                    this.goToPrevVisibleIndex();
                } else {
                    throw new Error("Bad parameter direction = " + direction);
                }

                toolbarSearch.scrollToResult(this.selection.catId + '_' + this.selection.position);
            };

            $scope.updateVisibleCategories = function() {
                this.visibleCategories = this.categories.filter(function(category) {
                    return (
                        typeof this.results[category.id] !== 'undefined' &&
                            this.results[category.id].length > 0
                        );
                }, this);
            };

            /**
             * Moves the keyboard navigation selection down
             */
            $scope.goToNextVisibleIndex = function() {
                var catIndex, catId, limit, newCatIndex;

                if (this.selection === null) {
                    // If there is nothing selected, we just select the first
                    // item and exit
                    this.selection = {
                        catIndex: 0,
                        catId: this.visibleCategories[0].id,
                        position: 0
                    };
                    return;
                }

                catIndex = this.selection.catIndex;
                catId = this.selection.catId;
                limit = Math.min(this.getResultLimit(catId) - 1, this.results[catId].length - 1);

                if (this.selection.position >= limit) {
                    // Move to first item in next category
                    newCatIndex = (catIndex == this.visibleCategories.length - 1) ? 0 : catIndex + 1;
                    this.selection = {
                        catIndex: newCatIndex,
                        catId: this.visibleCategories[newCatIndex].id,
                        position: 0
                    }
                } else {
                    // Advance pointer in current category
                    this.selection.position++;
                }
            };

            /**
             * Moves the keyboard navigation selection up
             */
            $scope.goToPrevVisibleIndex = function() {
                var catIndex, newCatIndex, newCatId, newCatPos;

                if (this.selection === null) {
                    // If there is no selection we act as if the first element
                    // were selected and continue with normal flow
                    this.selection = {
                        catIndex: 0,
                        catId: this.visibleCategories[0].id,
                        position: 0
                    }
                }

                catIndex = this.selection.catIndex;

                if (this.selection.position == 0) {
                    // Move to previous category
                    newCatIndex = (catIndex == 0) ? this.visibleCategories.length - 1 : catIndex - 1;
                    newCatId = this.visibleCategories[newCatIndex].id;
                    newCatPos = Math.min(this.getResultLimit(newCatId) - 1, this.results[newCatId].length - 1);

                    this.selection = {
                        catIndex: newCatIndex,
                        catId: newCatId,
                        position: newCatPos
                    }
                } else {
                    // Just move pointer to previous item
                    this.selection.position--;
                }
            };

            $scope.clearSelection = function() {
                this.selection = null;
            };

            /**
             * Executes the result action on the current selection
             */
            $scope.openSelection = function() {
                if (this.selection === null) {
                    return;
                }
                var pos = this.selection.position,
                    catId = this.selection.catId;
                toolbarSearch.openResult(null, pos, this.results[catId][pos], catId);
            };

            /**
             * Determines if a result is selected (if it should be highlighted
             * in the view
             * @param {Object} result
             * @returns {boolean}
             */
            $scope.isSelected = function(result) {
                if (this.selection === null) {
                    return false;
                }
                return this.results[this.selection.catId][this.selection.position] === result;
            };

            /**
             * Refresh the results view when a webcomponent is (un)installed. The results
             * remain the same, but their category might change (installed vs noninstalled)
             * so we need to regenerate the view model
             */
            $(document).bind('diy-editor-appscatalog-wc-installed diy-editor-appscatalog-wc-uninstalled',
                function() {
                    $scope.$apply(function() {
                        $scope.calculateViewResults();
                    });
                }
            );

            // Update the view model when the results change
            $scope.$watch('searchResults', function() {
                $scope.calculateViewResults();
            });

            $scope.$watch('results', function(newValue, prevValue) {
                $scope.resetResultLimit();
                refreshScroller();
                $scope.clearSelection();
            })
    }]);

    /*
     * We configure the location service to use html5mode, which avoids a nasty
     * bug where angular would prepend a slash to the hashbang
     * (e.g. #/hm:cc-sa-item-elements), breaking the existing history manager
     * This avoids hacking the angular.js file with the "remove forwardslash" patch
     * (see the file in the folder where angular.js resides)
     */
    search.config(['$locationProvider', function($locationProvider) {
       $locationProvider.html5Mode({
           enabled: true,
           requireBase: false
       });
    }]);

    //TODO: put this template in a separate html file
    search.run(['$templateCache', 'diyl10n', function($templateCache, diyl10n) {

        $templateCache.put('searchResults.html',
            '<div class="results-wrapper" ng-hide="results | isEmpty">' +
                '<div class="category" ' +
                        'ng-repeat="cat in categories" ' +
                        'ng-if="results[cat.id].length > 0"' +
                '>' +
                    //TODO: abstract squeezebox markup
                    '<div class="diye-collapsible-category-header">' +
                        '<div class="diye-collapsible-category-positioned">' +
                            '<div class="diye-collapsible-category-title">' +
                                '<span ng-bind-html="cat.title"></span> ' +
                                '<span class="result-count">({{results[cat.id].length}})</span>' +
                            '</div>' +
                            '<div class="diye-collapsible-category-pointer"></div>' +
                            '<div class="diye-collapsible-category-arrow"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="diye-collapsible-category-content" ng-switch="cat.id">' +
                        '<div ng-switch-when="help">' +
                            '<ul class="results">' +
                                '<li class="result" data-result-id="{{cat.id}}_{{$index}}" ' +
                                    'ng-repeat="result in results[cat.id] | limitTo: getResultLimit(cat.id)" ' +
                                    'ng-class="{\'result-featured\': result.featured, \'result-active\': isSelected(result)}">' +

                                    '<a href="JavaScript:;" ng-click="resultClick($event, $index, result, cat.id)">' +

                                        '<span class="ui-icon" ng-class="{\'ui-icon-star\': result.featured, \'ui-icon-help\': !result.featured}"></span>' +
                                        '<div class="result-content">' +
                                            '<h3>{{result.title}}</h3>' +
                                            '<p>{{result.description}}</p>' +
                                        '</div>' +
                                    '</a>' +
                                '</li>' +
                            '</ul>' +

                            '<div class="more-results" ng-show="getResultLimit(cat.id) < results[cat.id].length">' +
                                '<a href="Javascript:;" ng-click="showMoreResults(cat.id)">' +
                                    '<span class="ui-icon"></span>' +
                                    diyl10n('toolbarSearch.showMoreResults') +
                                '</a>' +
                            '</div>' +
                        '</div>' +
                        '<div ng-switch-default>' +
                            '<ul class="results">' +
                                '<li class="result result-big" data-result-id="{{cat.id}}_{{$index}}" ' +
                                    'ng-repeat="result in results[cat.id] | limitTo: getResultLimit(cat.id)" ' +
                                    'ng-class="{\'result-active\': isSelected(result)}" ' +
                                '>' +
                                    '<a class="clearfix" href="JavaScript:;" ng-click="resultClick($event, $index, result, cat.id)">' +

                                        '<span class="ui-icon {{result.additionalCssClasses}}" style="background-image: url({{result.iconUrl}});"></span>' +
                                        '<div class="result-content">' +
                                            '<h3>{{result.name}}</h3>' +
                                            '<p>{{result.shortDescription}}</p>' +
                                        '</div>' +
                                    '</a>' +
                                '</li>' +
                            '</ul>' +

                            '<div class="more-results" ng-show="getResultLimit(cat.id) < results[cat.id].length">' +
                                '<a href="Javascript:;" ng-click="showMoreResults(cat.id)">' +
                                    '<span class="ui-icon {{result.additionalCssClasses}}"></span>' +
                                    diyl10n('toolbarSearch.showMoreResults') +
                                '</a>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="no-results-wrapper" ng-show="results | isEmpty">' +
                '<div class="no-results">' +
                    '<h3 class="subheading">' + diyl10n('toolbarSearch.noresults.message') + '</h3>' +
                    '<p ng-show="hasHelpSearch()">' + diyl10n('toolbarSearch.noresults.moreinfo') + '</p>' +
                '</div>' +
            '</div>'
        );
    }]);

    exports.init = function(_toolbarSearch) {
        toolbarSearch = _toolbarSearch;
    };
}());




/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/search/search-module.js
 ** module id = 856
 ** module chunks = 0
 **/